import * as _ from 'lodash';
import * as CG from './cg/graph';
import * as Types from './types';

interface PathObjToTSTypeWithPath<T extends Types.Type> {
  path: CG.Node<T>;
}

type PathDictToTSTypeWithPath<T extends Types.Type> = Array<{
  key: string;
  path: CG.Node<T>;
}>;

type UnionType<T extends Types.Union> = {
  [K in keyof T['members']]: K extends number
    ? TypeToTSTypeWithPath<T['members'][K]>
    : never;
};

export type TypeToTSTypeWithPath<T extends Types.Type> = T extends Types.Union
  ? UnionType<T>[number] // : T extends Dict // ? PathDictToTSTypeWithPath<T['objectType']>
  : PathObjToTSTypeWithPath<T>;

export type PathObjOrDictWithPath<T extends Types.Type> =
  // | PathDictToTSTypeWithPath<T>
  PathObjToTSTypeWithPath<T>;

export function isSinglePathObjTSType<T extends Types.Type>(
  type: PathDictToTSTypeWithPath<T> | PathObjToTSTypeWithPath<T>
): type is PathObjToTSTypeWithPath<T> {
  return !_.isArray(type);
}
